/**
 * Shared RAQB (react-awesome-query-builder) styles applied via MuiCssBaseline.
 * Scoped to `.query-builder` so they only affect Keyword Logic / similar builders.
 *
 * Use explicit `px` (not rem) — rem can resolve smaller than expected depending on root font size.
 */
export const queryBuilderCssBaselineOverrides = {
    '.query-builder': {
        '--main-font-size': '14px',
        fontSize: '14px',
        lineHeight: 1.45,

        // "Add rule" / "Add group" / "Add sub rule"
        '& .group--actions .MuiButton-root': {
            fontSize: '14px !important',
            fontWeight: 600,
            lineHeight: 1.5,
            textTransform: 'none',
        },
        '& .group--actions .MuiButton-startIcon > *:nth-of-type(1)': {
            fontSize: '18px !important',
        },

        // "Not" / And / Or conjunction buttons
        '& .group--conjunctions .MuiButton-root': {
            fontSize: '14px !important',
            fontWeight: 600,
            lineHeight: 1.5,
            textTransform: 'none',
            minHeight: '36px',
            paddingLeft: '12px',
            paddingRight: '12px',
        },

        // Field / operator selects — room for long DocumentViewModel paths
        '& .MuiFormControl-root': {
            minWidth: 400,
        },
        '& .MuiInputBase-root': {
            minWidth: 400,
            fontSize: '14px',
        },
        '& .MuiSelect-select': {
            minWidth: 380,
            fontSize: '14px',
            paddingRight: '32px !important',
        },
        '& .MuiFormLabel-root, & .MuiInputLabel-root': {
            fontSize: '14px',
        },
    },
} as const;

/** Keyword-path tooltips — MUI default is ~11px; force 14px. */
export const queryBuilderTooltipOverrides = {
    tooltip: {
        fontSize: '14px !important',
        lineHeight: 1.45,
        maxWidth: 520,
        padding: '8px 12px',
    },
} as const;

/**
 * GlobalStyles payload for the Keyword Logic editor dialog.
 * Applied while the dialog is open so portaled tooltips (outside .query-builder) also get 14px.
 */
export const keywordLogicEditorGlobalStyles = {
    '.query-builder .group--actions .MuiButton-root': {
        fontSize: '14px !important',
        fontWeight: 600,
        lineHeight: 1.5,
        textTransform: 'none',
    },
    '.query-builder .group--actions .MuiButton-startIcon > *:nth-of-type(1)': {
        fontSize: '18px !important',
    },
    '.query-builder .group--conjunctions .MuiButton-root': {
        fontSize: '14px !important',
        fontWeight: 600,
        lineHeight: 1.5,
        textTransform: 'none',
        minHeight: '36px',
        paddingLeft: '12px',
        paddingRight: '12px',
    },
    '.query-builder .MuiFormControl-root, .query-builder .MuiInputBase-root': {
        minWidth: 400,
    },
    '.query-builder .MuiSelect-select': {
        minWidth: 380,
        fontSize: '14px',
    },
    '.MuiTooltip-tooltip': {
        fontSize: '14px !important',
        lineHeight: 1.45,
        maxWidth: 520,
    },
} as const;
